import React from 'react';
import { EmergencyDisclaimerMarkdown } from './EmergencyDisclaimerMarkdown';
import { EmergencyDisclaimerSimple } from './EmergencyDisclaimerSimple';
import { PMCConfig } from '@kyruus/types';
import { Log } from 'Src/types';

interface EmergencyDisclaimerProps {
  config: PMCConfig;
  closeButtonAriaLabel: string;
  log: Log;
}
export const EmergencyDisclaimer = ({
  config,
  log,
  closeButtonAriaLabel
}: EmergencyDisclaimerProps) => {
  if (config.emergency_disclaimer_md?.enabled) {
    return (
      <EmergencyDisclaimerMarkdown
        bannerConfig={config.emergency_disclaimer_md}
        closeButtonAriaLabel={closeButtonAriaLabel}
        log={log}
      />
    );
  } else if (config.emergency_disclaimer?.enabled) {
    return (
      <EmergencyDisclaimerSimple
        bannerConfig={config.emergency_disclaimer}
        closeButtonAriaLabel={closeButtonAriaLabel}
        log={log}
      />
    );
  } else {
    return null;
  }
};
